import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { LoanRoutingModule } from './loan-routing.module';
import { LoanComponent } from './loan.component';
import { ModalFinishByPhoneModule } from 'src/app/components/modals/modal-finish-by-phone/modal-finish-by-phone.module';
import { ModalBranchInfoModule } from 'src/app/components/modals/modal-branch-info/modal-branch-info.module';
import { BranchInfoModule } from 'src/app/components/branches/branch-info/branch-info.module';
import { ErrorAlertModule } from 'src/app/components/error-alert/error-alert.module';

@NgModule({
  declarations: [LoanComponent],
  imports: [
    CommonModule,
    LoanRoutingModule,
    NgbDropdownModule,
    ModalFinishByPhoneModule,
    ModalBranchInfoModule,
    BranchInfoModule,
    ErrorAlertModule,
  ],
})
export class LoanModule {}
